export default "__VITE_ASSET___edW51Kj__"